export enum AdditionalOrderInformationType {
	UNKNOWN = 'UNKNOWN',
	YES_NO = 'YES_NO',
	DROPDOWN = 'DROPDOWN',
	TEXT = 'TEXT'
}
